export default "__VITE_PUBLIC_ASSET__652690bf__"